import { useAppStore } from '../store/useAppStore'

const useVehicleId = () => {
  const vehicleId = useAppStore((state) => state.vehicleId)
  const setVehicleId = useAppStore((state) => state.setVehicleId)

  // Check if vehicleId is undefined then try to get it from URL it's the initial value
  // If vehicleId is already set, we don't need to do anything
  // vehicleId can be 'null', 'nil' or undefined
  if (vehicleId === undefined) {
    const urlParams = new URLSearchParams(window.location.search)
    const vehicleIdFromURL = urlParams.get('vehicleId')
    if (['null', 'nil'].includes(vehicleIdFromURL)) {
      setVehicleId(null)
    } else {
      setVehicleId(vehicleIdFromURL)
    }
  }

  return vehicleId
}

export default useVehicleId
